import OrderPaymentDetails from './OrderPaymentDetails'
export default OrderPaymentDetails
